package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SyncCursorQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun getCursor(entity: String): Query<Long> = GetCursorQuery(entity) { cursor ->
    cursor.getLong(0)!!
  }

  public fun upsertCursor(entity: String, last_pulled_at: Long) {
    driver.execute(926_304_400, """
        |INSERT OR REPLACE INTO sync_cursor(entity, last_pulled_at)
        |VALUES (?, ?)
        """.trimMargin(), 2) {
          bindString(0, entity)
          bindLong(1, last_pulled_at)
        }
    notifyQueries(926_304_400) { emit ->
      emit("sync_cursor")
    }
  }

  public fun clearAll() {
    driver.execute(161_802_431, """DELETE FROM sync_cursor""", 0)
    notifyQueries(161_802_431) { emit ->
      emit("sync_cursor")
    }
  }

  private inner class GetCursorQuery<out T : Any>(
    public val entity: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("sync_cursor", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("sync_cursor", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_955_696_895,
        """SELECT last_pulled_at FROM sync_cursor WHERE entity = ?""", mapper, 1) {
      bindString(0, entity)
    }

    override fun toString(): String = "SyncCursor.sq:getCursor"
  }
}
